import { useLang } from "@/contexts/LanguageContext";
import { useEffect } from "react";

// Lightweight per-page <head> manager (no extra deps).
// Updates document.title, meta description, and og:* tags.
export default function PageHead({ titleKey, descriptionKey, customTitle, customDesc }) {
  const { lang, t } = useLang();

  useEffect(() => {
    const brand = lang === "ar" ? t.meta.siteName : "ELITE AL HIJAZ Est.";
    const title = customTitle || `${titleKey ? t.nav[titleKey] || titleKey : t.hero.title} · ${brand}`;
    const desc = customDesc || (descriptionKey ? t[descriptionKey] : t.hero.subtitle);
    document.title = title;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [k, v] = selector.replace(/[[\]"']/g, "").split("=");
        if (k && v) el.setAttribute(k, v);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', "content", desc);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", desc);
  }, [lang, t, titleKey, descriptionKey, customTitle, customDesc]);

  return null;
}
